import Axios from 'axios';
import GoogleMapReact from 'google-map-react';
import React, { useEffect } from "react";
import { GOOGLE_API_KEY } from '../../../constants/api-constants';
import Point from "../../atoms/point/point";
import "./google-api.scss";

const GoogleApi = ({ adress, setAdress, defaulGeo, setDefaulGeo, corMarket, setCorMarket, setGooglemaps }) => {

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(position => {
      setDefaulGeo({
        center: {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        },
        zoom: 17
      })
      setCorMarket({
        lat: position.coords.latitude,
        lng: position.coords.longitude
      });
    })
  }, []);

  const onCircleInteraction = (childKey, childProps, mouse) => {
    // function is just a stub to test callbacks
    setCorMarket({
      dragg: false,
      lat: mouse.lat,
      lng: mouse.lng
    });
    // setLat(mouse.lat);
    // setLng(mouse.lng);
  }

  const onCircleInteraction3 = (childKey, childProps, mouse) => {
    // function is just a stub to test callbacks
    const GOOGLE_API_KEY_II = "AIzaSyBfSCVlIfp7EEmQP9r68O2ffRrpMqA1Qn0";
    setCorMarket({
      dragg: true,
      lat: mouse.lat,
      lng: mouse.lng
    });
    // setLat(mouse.lat);
    // setLng(mouse.lng);
    Axios.get("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + mouse.lat + "," + mouse.lng + "&key=" + GOOGLE_API_KEY_II).then(resp => {
      var results = resp.data.results;
      setAdress({ search: results[0].formatted_address, value: results[0].formatted_address })
    })
  }

  return (
    <div>
      <p className="f-step-register-copy f-step-register-copy-bold">Ubica el pin rojo en la posición exacta o más cercana a tu ubicación.</p>
      <div className="f-map-content">
        <GoogleMapReact onChildMouseUp={onCircleInteraction3} onChildMouseDown={onCircleInteraction} onChildMouseMove={onCircleInteraction}
          draggable={corMarket.dragg}
          bootstrapURLKeys={{
            key: GOOGLE_API_KEY,
            libraries: "places"
          }}
          center={defaulGeo.center}
          zoom={defaulGeo.zoom}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => setGooglemaps(maps)}
          onClick={(data) => {
            setDefaulGeo({
              center: {
                lat: data.lat,
                lng: data.lng
              },
              zoom: 17
            })
            setCorMarket({
              lat: data.lat,
              lng: data.lng
            });
            Axios.get("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + data.lat + "," + data.lng + "&key=" + GOOGLE_API_KEY).then(resp => {
              var results = resp.data.results;
              setAdress({ search: results[0].formatted_address, value: results[0].formatted_address })
            })
          }} >
          <Point adress={adress.value} lat={corMarket.lat} lng={corMarket.lng} />
        </GoogleMapReact>
      </div>
    </div>
  )
}

export default GoogleApi;